import './ShipmentDetails.css';
import DataSection from "./sub/DataSection/DataSection.jsx";
import {useEffect, useState} from "react";
import {getDeliveryAddresses} from "../../../../CustomerHandler.js";

export default function ShipmentDetails() {
    const [shipmentData, setShipmentData] = useState([]);

    useEffect(() => {
        const fetchShipmentData = async () => {
            const token = sessionStorage.getItem("customerAccessToken");
            const data = await getDeliveryAddresses(token);

            setShipmentData(data);
        };
        fetchShipmentData();
    }, []);

    return (
        <div id='shipment-details'>
            <span id="shipment-details-label-1">Dane do zamówień</span>
            <DataSection
                label="Dane dostawy"
                data={shipmentData}
                type="shipment"
                setShipmentData={setShipmentData}
            />
        </div>
    );
}
